<ng-container *ngIf="{ desktop: mediaService.desktop$ | async } as state">

  <ng-container *ngIf="loadPlanningService.loading$ | async">
    <mat-progress-spinner [diameter]="state.desktop ? 20 : 12" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
  </ng-container>

  <ng-container *ngIf="loadPlanningService.loadPlanning$ | async as loadplanning">
    <!-- loadplanning stuff -->
    <!-- <ng-container *ngIf="state?.extras">
        <div class="block centered" fxHide fxShow.gt-sm>
          <pre title="{{ state?.report }}">{{ state?.extras?.rows }}</pre>
        </div>
        <div class="divider" fxHide fxShow.gt-sm></div>
      </ng-container> -->

    <!-- cart numbers -->
    <div class="block" (click)="loadplanning && showLoadplanning()">
      <p>{{ totals.volume }} {{ 'UNITS.VOLUME_METERS_CUBE' | translate }}</p>
    </div>
    <div class="divider"></div>
    <div class="block" (click)="loadplanning && showLoadplanning()">
      <p>{{ totals.weight }} {{ 'UNITS.WEIGHT_KILOGRAMS' | translate }}</p>
    </div>
    <div class="divider"></div>
    <div class="block" (click)="loadplanning && showLoadplanning()">
      <span class="super" *ngIf="state.desktop">{{ 'LOADPLANNING.AVAILABLE_SIZE' | translate }}</span>
      <p>{{ loadplanning?.extras?.nextSize || '-' }}</p>
    </div>

    <div class="divider" *ngIf="state.desktop"></div>
    <!-- loadplanning popup -->
    <div class="block no-padding" *ngIf="state.desktop">
      <button mat-flat-button (click)="showLoadplanning()">
        <mat-icon>info</mat-icon>
      </button>
    </div>

    <!-- truck icon -->
    <app-truck [link]="['..', 'cart']" [class.desktop]="mediaService.desktop$ | async"></app-truck>

  </ng-container>
</ng-container>
